import {
    Dialog,
    DialogDismiss,
    DialogHeader,
    DialogHeading,
    DialogBody,
    DialogDisclosure
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {useTranslation} from '@/translations/i18n'
import {DialogProvider, DialogStore} from '@ariakit/react'
import {AbsenceForm} from '../absence-form/AbsenceForm'
import {AbsenceFormProvider} from '../absence-form/AbsenceFormProvider'
import {AbsenceDialogFooter} from '../create-absence-dialog/AbsenceDialogFooter'
import {Access} from '../../types'
import {ReactElement, useMemo} from 'react'
import {mapAccessToFormValues} from '../../utils'

interface EditAbsenceDialogProps {
    access: Access
    dialogStore?: DialogStore
    trigger?: ReactElement
}

export const EditAbsenceDialog = ({access, dialogStore, trigger}: EditAbsenceDialogProps) => {
    return (
        <DialogProvider store={dialogStore}>
            {trigger ? <DialogDisclosure render={trigger} /> : null}
            <Dialog width="680px" overflowY="unset">
                <EditAbsenceDialogContent access={access} />
            </Dialog>
        </DialogProvider>
    )
}

interface EditAbsenceDialogContentProps {
    access: Access
}

const EditAbsenceDialogContent = ({access}: EditAbsenceDialogContentProps) => {
    const {t} = useTranslation()

    const defaultValues = useMemo(() => mapAccessToFormValues(access), [access])

    return (
        <>
            <DialogHeader>
                <DialogHeading>{t('accesses:edit_absence')}</DialogHeading>
                <DialogDismiss />
            </DialogHeader>
            <AbsenceFormProvider defaultValues={defaultValues}>
                <DialogBody>
                    <AbsenceForm isEdit />
                </DialogBody>
                <AbsenceDialogFooter accessId={access.id} />
            </AbsenceFormProvider>
        </>
    )
}
